import _classCallCheck from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/createClass";
export var LineDrawer = /*#__PURE__*/function () {
  function LineDrawer() {
    _classCallCheck(this, LineDrawer);
  }
  _createClass(LineDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 1;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.moveTo(-radius / 2, 0);
      context.lineTo(radius / 2, 0);
    }
  }]);
  return LineDrawer;
}();